interface Props {
  fill?: string;
  bgFill?: string;
  width?: string;
  height?: string;
  className?: string;
}

export const ECommerceIcon: React.FC<Props> = ({ fill = '#081120' }) => (
  <svg
    width="28"
    height="28"
    viewBox="0 0 28 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.5 7.00033H17.5C17.5 5.06733 15.933 3.50033 14 3.50033C12.0669 3.50033 10.5 5.06733 10.5 7.00033ZM8.16667 7.00033C8.16667 3.77867 10.7783 1.16699 14 1.16699C17.2216 1.16699 19.8333 3.77867 19.8333 7.00033H23.3333C23.9777 7.00033 24.5 7.52267 24.5 8.16699V24.5003C24.5 25.1447 23.9777 25.667 23.3333 25.667H4.66667C4.02234 25.667 3.5 25.1447 3.5 24.5003V8.16699C3.5 7.52267 4.02234 7.00033 4.66667 7.00033H8.16667ZM5.83333 9.33366V23.3337H22.1667V9.33366H5.83333ZM10.5 11.667C10.5 13.6 12.0669 15.167 14 15.167C15.933 15.167 17.5 13.6 17.5 11.667H19.8333C19.8333 14.8886 17.2216 17.5003 14 17.5003C10.7783 17.5003 8.16667 14.8886 8.16667 11.667H10.5Z"
      fill={fill}
    />
  </svg>
);

export const LogisticsBike: React.FC<Props> = ({ fill = '#8E8E93' }) => (
  <svg
    width="25"
    height="25"
    viewBox="0 0 25 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16.6654 0.166992C17.3097 0.166992 17.832 0.689332 17.832 1.33366V2.50033H23.6654V9.50033H21.3102L24.5136 18.3015C24.7192 18.8276 24.832 19.4002 24.832 19.9992C24.832 22.5766 22.7426 24.6658 20.1654 24.6658C17.9913 24.6658 16.1645 23.1791 15.646 21.167H10.685C10.1669 23.1797 8.33984 24.667 6.16536 24.667C3.89679 24.667 2.00629 23.0482 1.58589 20.9029C0.840651 20.5132 0.332031 19.7328 0.332031 18.8337V7.16699C0.332031 6.52267 0.854371 6.00033 1.4987 6.00033H9.66536C10.3097 6.00033 10.832 6.52267 10.832 7.16699V13.0003C10.832 13.6447 11.3543 14.167 11.9987 14.167H14.332C14.9764 14.167 15.4987 13.6447 15.4987 13.0003V2.50033H11.9987V0.166992H16.6654ZM6.16536 17.667C4.8767 17.667 3.83203 18.7116 3.83203 20.0003C3.83203 21.289 4.8767 22.3337 6.16536 22.3337C7.45403 22.3337 8.4987 21.289 8.4987 20.0003C8.4987 18.7116 7.45403 17.667 6.16536 17.667ZM20.1654 17.6658C18.8767 17.6658 17.832 18.7105 17.832 19.9992C17.832 21.2879 18.8767 22.3325 20.1654 22.3325C21.4541 22.3325 22.4987 21.2879 22.4987 19.9992C22.4987 19.7188 22.4492 19.4499 22.3586 19.2009L22.3394 19.1503C21.9999 18.2814 21.1546 17.6658 20.1654 17.6658ZM18.8272 9.50033H17.832V13.0003C17.832 14.9334 16.2651 16.5003 14.332 16.5003H11.9987C10.0656 16.5003 8.4987 14.9334 8.4987 13.0003H2.66536V16.9136C3.52046 15.9448 4.77156 15.3337 6.16536 15.3337C8.33984 15.3337 10.1669 16.8209 10.685 18.8337H15.6455C16.1631 16.8203 17.9905 15.3325 20.1654 15.3325C20.4416 15.3325 20.7123 15.3565 20.9754 15.4026L18.8272 9.50033ZM8.4987 8.33366H2.66536V10.667H8.4987V8.33366ZM21.332 4.83366H17.832V7.16699H21.332V4.83366Z"
      fill={fill}
    />
  </svg>
);

export const ProfileOutline: React.FC<Props> = ({ fill = '#8E8E93' }) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12C0 5.37258 5.37258 0 12 0ZM12.1916 16.8C9.74916 16.8 7.55018 17.8424 6.01531 19.5067C7.65647 20.8169 9.7368 21.6 12 21.6C14.3634 21.6 16.5272 20.746 18.1999 19.3297C16.6747 17.7689 14.5463 16.8 12.1916 16.8ZM12 2.4C6.69806 2.4 2.4 6.69806 2.4 12C2.4 14.1727 3.1218 16.1768 4.33868 17.7857C6.30767 15.7009 9.09773 14.4 12.1916 14.4C15.1729 14.4 17.872 15.6079 19.8262 17.561C20.9431 15.992 21.6 14.0728 21.6 12C21.6 6.69806 17.302 2.4 12 2.4ZM12 3.6C14.6509 3.6 16.8 5.74903 16.8 8.4C16.8 11.0509 14.6509 13.2 12 13.2C9.34903 13.2 7.2 11.0509 7.2 8.4C7.2 5.74903 9.34903 3.6 12 3.6ZM12 6C10.6745 6 9.6 7.07452 9.6 8.4C9.6 9.72552 10.6745 10.8 12 10.8C13.3255 10.8 14.4 9.72552 14.4 8.4C14.4 7.07452 13.3255 6 12 6Z"
      fill={fill}
    />
  </svg>
);

export const SettingsOutline: React.FC<Props> = ({ fill = '#8E8E93' }) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0.332031 11.9998C0.332031 10.9912 0.460014 10.0125 0.70064 9.07903C1.97262 9.14497 3.23526 8.51184 3.9158 7.33312C4.59581 6.15529 4.51343 4.74649 3.82178 3.67818C5.21283 2.31117 6.94507 1.29025 8.87907 0.754883C9.45793 1.88949 10.6375 2.66645 11.9987 2.66645C13.3598 2.66645 14.5395 1.88949 15.1184 0.754883C17.0523 1.29025 18.7846 2.31117 20.1756 3.67818C19.4839 4.74649 19.4015 6.15529 20.0816 7.33312C20.7621 8.51184 22.0248 9.14497 23.2968 9.07903C23.5374 10.0125 23.6654 10.9912 23.6654 11.9998C23.6654 13.0083 23.5374 13.9871 23.2968 14.9205C22.0248 14.8546 20.7621 15.4877 20.0816 16.6664C19.4015 17.8443 19.4839 19.253 20.1756 20.3214C18.7846 21.6883 17.0523 22.7093 15.1184 23.2447C14.5395 22.1101 13.3598 21.3331 11.9987 21.3331C10.6375 21.3331 9.45793 22.1101 8.87907 23.2447C6.94507 22.7093 5.21283 21.6883 3.82178 20.3214C4.51343 19.253 4.59581 17.8443 3.9158 16.6664C3.23526 15.4877 1.97262 14.8546 0.70064 14.9205C0.460014 13.9871 0.332031 13.0083 0.332031 11.9998ZM5.93652 15.4998C6.67164 16.7731 6.88237 18.2369 6.59491 19.6109C7.07066 19.9494 7.57709 20.2427 8.10774 20.4864C9.15409 19.5497 10.5278 18.9998 11.9987 18.9998C13.4696 18.9998 14.8433 19.5497 15.8896 20.4864C16.4202 20.2427 16.9267 19.9494 17.4025 19.6109C17.115 18.2369 17.3257 16.7731 18.0609 15.4998C18.7959 14.2266 19.9583 13.3123 21.2918 12.8742C21.3185 12.5851 21.332 12.2935 21.332 11.9998C21.332 11.7061 21.3185 11.4144 21.2918 11.1255C19.9583 10.6874 18.7959 9.77306 18.0609 8.49979C17.3257 7.22652 17.115 5.76274 17.4025 4.38872C16.9267 4.05019 16.4202 3.75688 15.8896 3.5131C14.8433 4.44984 13.4696 4.99979 11.9987 4.99979C10.5278 4.99979 9.15409 4.44984 8.10774 3.5131C7.57709 3.75688 7.07066 4.05019 6.59491 4.38872C6.88237 5.76274 6.67164 7.22652 5.93652 8.49979C5.20142 9.77306 4.03916 10.6874 2.70563 11.1255C2.67886 11.4144 2.66536 11.7061 2.66536 11.9998C2.66536 12.2935 2.67886 12.5851 2.70563 12.8742C4.03916 13.3123 5.20142 14.2266 5.93652 15.4998ZM11.9987 15.4998C10.0656 15.4998 8.4987 13.9328 8.4987 11.9998C8.4987 10.0668 10.0656 8.49979 11.9987 8.49979C13.9317 8.49979 15.4987 10.0668 15.4987 11.9998C15.4987 13.9328 13.9317 15.4998 11.9987 15.4998ZM11.9987 13.1664C12.643 13.1664 13.1654 12.6441 13.1654 11.9998C13.1654 11.3554 12.643 10.8331 11.9987 10.8331C11.3543 10.8331 10.832 11.3554 10.832 11.9998C10.832 12.6441 11.3543 13.1664 11.9987 13.1664Z"
      fill={fill}
    />
  </svg>
);

export const StackedOutline: React.FC<Props> = ({ fill = '#8E8E93' }) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1.66667 2.83333H20.3333V0.5H1.66667V2.83333ZM20.3333 7.5H1.66667V5.16667H20.3333V7.5ZM0.5 9.83333H8.66667V12.1667H13.3333V9.83333H21.5V20.3333C21.5 20.9777 20.9777 21.5 20.3333 21.5H1.66667C1.02234 21.5 0.5 20.9777 0.5 20.3333V9.83333ZM15.6667 12.1667V14.5H6.33333V12.1667H2.83333V19.1667H19.1667V12.1667H15.6667Z"
      fill={fill}
    />
  </svg>
);

export const WalletOutline: React.FC<Props> = ({ fill = '#8E8E93' }) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M23.6732 5.16667H24.8399V16.8333H23.6732V20.3333C23.6732 20.9777 23.1509 21.5 22.5065 21.5H1.50651C0.862184 21.5 0.339844 20.9777 0.339844 20.3333V1.66667C0.339844 1.02233 0.862184 0.5 1.50651 0.5H22.5065C23.1509 0.5 23.6732 1.02233 23.6732 1.66667V5.16667ZM21.3399 16.8333H14.3399C11.1182 16.8333 8.50651 14.2216 8.50651 11C8.50651 7.77833 11.1182 5.16667 14.3399 5.16667H21.3399V2.83333H2.67318V19.1667H21.3399V16.8333ZM22.5065 14.5V7.5H14.3399C12.4068 7.5 10.8399 9.06696 10.8399 11C10.8399 12.9329 12.4068 14.5 14.3399 14.5H22.5065ZM14.3399 9.83334H17.8399V12.1667H14.3399V9.83334Z"
      fill={fill}
    />
  </svg>
);

export const Profileline: React.FC<Props> = ({ fill = '#8E8E93' }) => (
  <svg
    width="28"
    height="28"
    viewBox="0 0 28 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M24.5092 3.5C25.1483 3.5 25.6663 4.01911 25.6663 4.65897V23.341C25.6663 23.9811 25.1352 24.5 24.5092 24.5H3.49011C2.85107 24.5 2.33301 23.9809 2.33301 23.341V4.65897C2.33301 4.01889 2.8642 3.5 3.49011 3.5H24.5092ZM23.333 5.83333H4.66634V22.1667H23.333V5.83333ZM20.9997 17.5V19.8333H6.99967V17.5H20.9997ZM13.9997 8.16667V15.1667H6.99967V8.16667H13.9997ZM20.9997 12.8333V15.1667H16.333V12.8333H20.9997ZM11.6663 10.5H9.33301V12.8333H11.6663V10.5ZM20.9997 8.16667V10.5H16.333V8.16667H20.9997Z"
      fill={fill}
    />
  </svg>
);

export const Leafline: React.FC<Props> = ({ fill = '#8E8E93' }) => (
  <svg
    width="28"
    height="28"
    viewBox="0 0 28 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M24.498 3.5V5.83333C24.498 17.0653 18.2301 22.1667 10.498 22.1667L6.11455 22.1665C5.92535 23.2307 5.83138 24.3915 5.83138 25.6667H3.49805C3.49805 24.0768 3.63304 22.633 3.90143 21.3129C3.63251 19.8031 3.49805 17.7539 3.49805 15.1667C3.49805 8.72334 8.72139 3.5 15.1647 3.5C17.498 3.5 19.8313 4.66667 24.498 3.5ZM15.1647 5.83333C10.0101 5.83333 5.83138 10.012 5.83138 15.1667C5.83138 15.5895 5.83511 15.9963 5.84251 16.3869C7.30596 14.0798 9.44918 12.2556 12.2525 10.6537L13.4102 12.6796C10.0795 14.5829 7.87012 16.7457 6.73583 19.8331L10.498 19.8333C17.5157 19.8333 22.0144 15.198 22.161 6.2856C20.5604 6.44132 19.0731 6.342 17.2383 6.06677C15.8953 5.86532 15.6323 5.83333 15.1647 5.83333Z"
      fill={fill}
    />
  </svg>
);

export const CutleryIconLine: React.FC<Props> = ({ fill = '#8E8E93' }) => (
  <svg
    width="28"
    height="28"
    viewBox="0 0 28 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M24.5 2.33203V25.6654H22.1667V16.332H18.6667V8.16536C18.6667 4.94371 21.2784 2.33203 24.5 2.33203ZM10.5 16.2154V25.6654H8.16667V16.2154C5.50405 15.6748 3.5 13.3209 3.5 10.4987V3.4987H5.83333V11.6654H8.16667V3.4987H10.5V11.6654H12.8333V3.4987H15.1667V10.4987C15.1667 13.3209 13.1626 15.6748 10.5 16.2154Z"
      fill={fill}
    />
  </svg>
);

export const WearIconLine: React.FC<Props> = ({ fill = '#8E8E93' }) => (
  <svg
    width="28"
    height="28"
    viewBox="0 0 28 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M26.9246 6.33282L21.6658 3.24298C21.4641 3.12398 21.234 3.06164 20.9997 3.06251H17.4997C17.1516 3.06251 16.8178 3.20079 16.5717 3.44693C16.3255 3.69307 16.1872 4.02691 16.1872 4.37501C16.1872 4.95517 15.9568 5.51157 15.5465 5.92181C15.1363 6.33204 14.5799 6.56251 13.9997 6.56251C13.4196 6.56251 12.8632 6.33204 12.4529 5.92181C12.0427 5.51157 11.8122 4.95517 11.8122 4.37501C11.8122 4.02691 11.674 3.69307 11.4278 3.44693C11.1817 3.20079 10.8478 3.06251 10.4997 3.06251H6.99973C6.76615 3.06236 6.53683 3.12507 6.33583 3.24407L1.07489 6.33282C0.601234 6.61557 0.25062 7.06543 0.0921106 7.59379C-0.0663992 8.12216 -0.0213144 8.69073 0.218485 9.18751L2.1763 13.2125C2.35086 13.5799 2.62624 13.8901 2.97035 14.107C3.31447 14.3239 3.71313 14.4385 4.11989 14.4375H5.68723V22.75C5.68723 23.3302 5.9177 23.8866 6.32794 24.2968C6.73817 24.707 7.29457 24.9375 7.87473 24.9375H20.1247C20.7049 24.9375 21.2613 24.707 21.6715 24.2968C22.0818 23.8866 22.3122 23.3302 22.3122 22.75V14.4375H23.8785C24.2845 14.4381 24.6823 14.3237 25.0259 14.1075C25.3695 13.8912 25.6448 13.5821 25.8199 13.2158L27.781 9.18751C28.0208 8.69073 28.0659 8.12216 27.9074 7.59379C27.7488 7.06543 27.3982 6.61557 26.9246 6.33282ZM4.4152 11.8125L2.75161 8.39235L5.68723 6.67188V11.8125H4.4152ZM19.6872 22.3125H8.31223V5.68751H9.36989C9.65505 6.69603 10.2617 7.58389 11.0975 8.21617C11.9334 8.84846 12.9528 9.19059 14.0008 9.19059C15.0489 9.19059 16.0683 8.84846 16.9042 8.21617C17.74 7.58389 18.3466 6.69603 18.6318 5.68751H19.6872V22.3125ZM23.5832 11.8125H22.3122V6.67188L25.2468 8.39563L23.5832 11.8125Z"
      fill={fill}
    />
  </svg>
);

export const ShoppingBasketLine: React.FC<Props> = ({ fill = '#8E8E93' }) => (
  <svg
    width="28"
    height="28"
    viewBox="0 0 28 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14.0056 2.33203C17.8715 2.33203 21.0056 5.46604 21.0056 9.33203V10.4987H25.6722V12.832H24.3107L23.428 23.4289C23.3776 24.0335 22.8721 24.4987 22.2653 24.4987H5.7457C5.13893 24.4987 4.63344 24.0335 4.58306 23.4289L3.6992 12.832H2.33887V10.4987H7.00553V9.33203C7.00553 5.46604 10.1395 2.33203 14.0056 2.33203ZM21.9692 12.832H6.0407L6.81887 22.1654H21.1911L21.9692 12.832ZM15.1722 15.1654V19.832H12.8389V15.1654H15.1722ZM10.5055 15.1654V19.832H8.1722V15.1654H10.5055ZM19.8389 15.1654V19.832H17.5056V15.1654H19.8389ZM14.0056 4.66536C11.5063 4.66536 9.46594 6.63 9.34458 9.09912L9.33887 9.33203V10.4987H18.6722V9.33203C18.6722 6.8328 16.7076 4.79244 14.2384 4.67108L14.0056 4.66536Z"
      fill={fill}
    />
  </svg>
);

export const LeafIconWonWithBG: React.FC<Props> = () => (
  <svg
    width="56"
    height="56"
    viewBox="0 0 56 56"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="56" height="56" rx="4" fill="#E6EDEE" />
    <path
      d="M39.996 16V18.6667C39.996 31.5032 32.8327 37.3333 23.9961 37.3333L18.9864 37.3332C18.7702 38.5493 18.6628 39.876 18.6628 41.3333H15.9961C15.9961 39.5164 16.1504 37.8663 16.4571 36.3576C16.1498 34.6321 15.9961 32.2901 15.9961 29.3333C15.9961 21.9695 21.9656 16 29.3294 16C31.996 16 34.6627 17.3333 39.996 16ZM29.3294 18.6667C23.4384 18.6667 18.6628 23.4423 18.6628 29.3333C18.6628 29.8165 18.667 30.2815 18.6755 30.7279C20.348 28.0912 22.7974 26.0064 26.0012 24.1757L27.3243 26.4909C23.5178 28.6661 20.9927 31.138 19.6964 34.6664L23.9961 34.6667C32.0163 34.6667 37.1576 29.3692 37.3252 19.1835C35.4959 19.3615 33.7962 19.248 31.6992 18.9335C30.1644 18.7032 29.8638 18.6667 29.3294 18.6667Z"
      fill="#054853"
    />
  </svg>
);

export const LogisticsBoxWithBG: React.FC<Props> = () => (
  <svg
    width="56"
    height="56"
    viewBox="0 0 56 56"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="56" height="56" rx="4" fill="#F2F2F7" />
    <path
      d="M27.9987 13.3333L40.6654 20.6666V35.3333L27.9987 42.6666L15.332 35.3333V20.6666L27.9987 13.3333ZM19.3239 21.4369L27.9988 26.4592L36.6736 21.437L27.9987 16.4146L19.3239 21.4369ZM17.9987 23.751V33.7958L26.6655 38.8134V28.7686L17.9987 23.751ZM29.3322 38.8133L37.9987 33.7958V23.7511L29.3322 28.7686V38.8133Z"
      fill="#636366"
    />
  </svg>
);

export const CutleryIconWonWithBG: React.FC<Props> = () => (
  <svg
    width="56"
    height="56"
    viewBox="0 0 56 56"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="56" height="56" rx="4" fill="#FFF9E4" />
    <path
      d="M40 14.668V41.3346H37.3333V30.668H33.3333V21.3346C33.3333 17.6527 36.3181 14.668 40 14.668ZM24 30.5346V41.3346H21.3333V30.5346C18.2903 29.9169 16 27.2266 16 24.0013V16.0013H18.6667V25.3346H21.3333V16.0013H24V25.3346H26.6667V16.0013H29.3333V24.0013C29.3333 27.2266 27.0429 29.9169 24 30.5346Z"
      fill="#FCCD33"
    />
  </svg>
);

export const BasketIconWonWithBG: React.FC<Props> = () => (
  <svg
    width="56"
    height="56"
    viewBox="0 0 56 56"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="56" height="56" rx="4" fill="#F2F2F7" />
    <path
      d="M28.0062 14.668C32.4245 14.668 36.0062 18.2497 36.0062 22.668V24.0013H41.3395V26.668H39.7835L38.7747 38.7786C38.7171 39.4697 38.1394 40.0013 37.4459 40.0013H18.5664C17.8729 40.0013 17.2952 39.4697 17.2376 38.7786L16.2275 26.668H14.6729V24.0013H20.0062V22.668C20.0062 18.2497 23.5879 14.668 28.0062 14.668ZM37.1075 26.668H18.9035L19.7929 37.3346H36.2182L37.1075 26.668ZM29.3395 29.3346V34.668H26.6729V29.3346H29.3395ZM24.0062 29.3346V34.668H21.3395V29.3346H24.0062ZM34.6729 29.3346V34.668H32.0062V29.3346H34.6729ZM28.0062 17.3346C25.1499 17.3346 22.8181 19.5799 22.6794 22.4018L22.6729 22.668V24.0013H33.3395V22.668C33.3395 19.8117 31.0942 17.4799 28.2723 17.3412L28.0062 17.3346Z"
      fill="#636366"
    />
  </svg>
);

export const WearIconWonWithBG: React.FC<Props> = () => (
  <svg
    width="56"
    height="56"
    viewBox="0 0 56 56"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="56" height="56" rx="4" fill="#FFF2EA" />
    <g clipPath="url(#clip0_56755_32315)">
      <path
        d="M42.7721 19.2375L36.7621 15.7063C36.5315 15.5703 36.2685 15.499 36.0008 15.5H32.0008C31.603 15.5 31.2215 15.658 30.9402 15.9394C30.6588 16.2207 30.5008 16.6022 30.5008 17C30.5008 17.6631 30.2374 18.2989 29.7686 18.7678C29.2997 19.2366 28.6639 19.5 28.0008 19.5C27.3378 19.5 26.7019 19.2366 26.233 18.7678C25.7642 18.2989 25.5008 17.6631 25.5008 17C25.5008 16.6022 25.3428 16.2207 25.0615 15.9394C24.7802 15.658 24.3986 15.5 24.0008 15.5H20.0008C19.7339 15.4998 19.4718 15.5715 19.2421 15.7075L13.2296 19.2375C12.6882 19.5606 12.2875 20.0748 12.1064 20.6786C11.9252 21.2825 11.9768 21.9323 12.2508 22.5L14.4883 27.1C14.6878 27.5199 15.0025 27.8744 15.3958 28.1223C15.7891 28.3702 16.2447 28.5012 16.7096 28.5H18.5008V38C18.5008 38.6631 18.7642 39.2989 19.233 39.7678C19.7019 40.2366 20.3378 40.5 21.0008 40.5H35.0008C35.6639 40.5 36.2997 40.2366 36.7686 39.7678C37.2374 39.2989 37.5008 38.6631 37.5008 38V28.5H39.2908C39.7548 28.5007 40.2095 28.3699 40.6022 28.1228C40.9948 27.8757 41.3095 27.5224 41.5096 27.1038L43.7508 22.5C44.0249 21.9323 44.0764 21.2825 43.8952 20.6786C43.7141 20.0748 43.3134 19.5606 42.7721 19.2375ZM17.0471 25.5L15.1458 21.5913L18.5008 19.625V25.5H17.0471ZM34.5008 37.5H21.5008V18.5H22.7096C23.0355 19.6526 23.7287 20.6673 24.684 21.3899C25.6392 22.1125 26.8043 22.5035 28.0021 22.5035C29.1998 22.5035 30.3649 22.1125 31.3201 21.3899C32.2754 20.6673 32.9687 19.6526 33.2946 18.5H34.5008V37.5ZM38.9533 25.5H37.5008V19.625L40.8546 21.595L38.9533 25.5Z"
        fill="#F7742B"
      />
    </g>
    <defs>
      <clipPath id="clip0_56755_32315">
        <rect
          width="32"
          height="32"
          fill="white"
          transform="translate(12 12)"
        />
      </clipPath>
    </defs>
  </svg>
);

export const CalendarIconWonWithBG: React.FC<Props> = ({ className }) => (
  <svg
    className={className}
    height="56"
    viewBox="0 0 56 56"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="56" height="56" rx="4" fill="#F2F2F7" />
    <path
      d="M24.0013 13.3335V16.0002H32.0013V13.3335H34.668V16.0002H40.0013C40.7377 16.0002 41.3346 16.5971 41.3346 17.3335V38.6668C41.3346 39.4032 40.7377 40.0002 40.0013 40.0002H16.0013C15.2649 40.0002 14.668 39.4032 14.668 38.6668V17.3335C14.668 16.5971 15.2649 16.0002 16.0013 16.0002H21.3346V13.3335H24.0013ZM38.668 26.6668H17.3346V37.3335H38.668V26.6668ZM22.668 30.6668V33.3335H20.0013V30.6668H22.668ZM36.0013 30.6668V33.3335H25.3346V30.6668H36.0013ZM21.3346 18.6668H17.3346V24.0002H38.668V18.6668H34.668V21.3335H32.0013V18.6668H24.0013V21.3335H21.3346V18.6668Z"
      fill="#636366"
    />
  </svg>
);

export const ProfileIconWithBG: React.FC<Props> = ({ className }) => (
  <svg
    className={className}
    height="56"
    viewBox="0 0 56 56"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="56" height="56" rx="4" fill="#EFEDFE" />
    <path
      d="M40.0113 16C40.7417 16 41.3337 16.5933 41.3337 17.3245V38.6755C41.3337 39.4069 40.7266 40 40.0113 40H15.9894C15.2591 40 14.667 39.4068 14.667 38.6755V17.3245C14.667 16.593 15.2741 16 15.9894 16H40.0113ZM38.667 18.6667H17.3337V37.3333H38.667V18.6667ZM36.0003 32V34.6667H20.0003V32H36.0003ZM28.0003 21.3333V29.3333H20.0003V21.3333H28.0003ZM36.0003 26.6667V29.3333H30.667V26.6667H36.0003ZM25.3337 24H22.667V26.6667H25.3337V24ZM36.0003 21.3333V24H30.667V21.3333H36.0003Z"
      fill="#5A4AF2"
    />
  </svg>
);

export const ArchiveDrawerWithBG: React.FC<Props> = ({ className }) => (
  <svg
    className={className}
    height="56"
    viewBox="0 0 56 56"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="56" height="56" rx="4" fill="#FFF9E4" />
    <path
      d="M16 15.9894C16 15.2591 16.5933 14.667 17.3245 14.667H38.6755C39.4069 14.667 40 15.2741 40 15.9894V40.0113C40 40.7417 39.4068 41.3337 38.6755 41.3337H17.3245C16.593 41.3337 16 40.7266 16 40.0113V15.9894ZM37.3333 26.667V17.3337H18.6667V26.667H37.3333ZM37.3333 29.3337H18.6667V38.667H37.3333V29.3337ZM24 20.0003H32V22.667H24V20.0003ZM24 32.0003H32V34.667H24V32.0003Z"
      fill="#FCCD33"
    />
  </svg>
);
